import {
  DeceasedReport,
  PrimaryReportResult,
  ReportResultStatus,
  ReportStatus,
  ReportType
} from '../models/report.model';

export const primaryReportExample:Extract<DeceasedReport, { type: ReportType.PRIMARY }> = {
  status: ReportStatus.PROCESSED,
  type: ReportType.PRIMARY,
  reportNumber: '2025/00000/PRZYKŁAD',
  order: {
    orderNumber: '2025/00000/PRZYKŁAD',
    updatedAt: new Date(),
    createdAt: new Date(),
    client: {
      name: 'Jan',
      lastName: 'Kowalski',
      email: 'jan.kowalski@mspadek.pl'
    }
  },
  updatedAt: new Date(),
  createdAt: new Date(),
  databaseStatusOn: new Date(),
  deceased: {
    name: 'Jan',
    lastName: 'Kowalski',
    peselNumber: '00000000000',
    dateOfDeath: new Date(),
    taxId: '000000000'
  },
  lookup: {
    ceidg: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    crbr: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    krz: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    msig: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    sudop: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    vatWl: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    },
    krs: {
      status: ReportStatus.PROCESSED,
      timestamp: new Date(),
    }
  },
  result: {
    ceidg: ReportResultStatus.EXISTS,
    crbr: ReportResultStatus.EXISTS,
    krz: ReportResultStatus.NOT_EXISTS,
    sudop: ReportResultStatus.SKIPPED,
   msig: ReportResultStatus.NOT_EXISTS,
   vatWl: ReportResultStatus.SKIPPED,
   krs: {
      companyAuthorities: ReportResultStatus.EXISTS,
     propertyRights: ReportResultStatus.NOT_EXISTS
   }
  }

}
